import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteMarketingCampaign } from "./deleteMarketingCampaign.request";

const useDeleteMarketingCampaign = (
  options?: MutationOptions<
    { ok: boolean },
    ApiServiceError<ApiError>,
    string
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestDeleteMarketingCampaign,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["marketing", "campaigns"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useDeleteMarketingCampaign;
